import { InvitesApi } from "@/api/invites";
import { ReplenishInvitesRequest } from "@/api/invites/types";
import { QueryKey } from "@/utils";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNotify } from "react-admin";

export const useReplenishInvites = (onClose: () => void) => {
  const queryClient = useQueryClient();
  const notify = useNotify();

  const { mutate: replenishInvites, isPending } = useMutation({
    mutationFn: (body: ReplenishInvitesRequest) =>
      InvitesApi.replenishInvites(body),
    onError: (error) => {
      notify(error, { type: "error" });
    },
    onSuccess: (_, { userId }) => {
      queryClient.invalidateQueries({ queryKey: [QueryKey.USER, userId] });
      queryClient.invalidateQueries({ queryKey: [QueryKey.INVITE, userId] });
      notify("Invites replenished!", { type: "success" });
    },
    onSettled: () => {
      onClose();
    },
  });

  return {
    replenishInvites,
    replenishInvitesIsPending: isPending,
  };
};
